import { Provider } from '@angular/core';
import { ProductTypes, wireItemConverter, wireItemPricingConverter, wireProductDetailsConverter } from 'products-data';
import { provideItemResultComponent } from '../../item';
import { CommonItemResultLayoutComponentsProviderComponent } from '../../item/types/common/common-item-result-layout-components-provider/common-item-result-layout-components-provider.component';
import { WireCutItemResultLayoutComponentsProviderComponent } from '../../item/types/wire-cut/component-provider/wire-cute-item-result-layout-components-provider/wire-cut-item-result-layout-components-provider.component';
import { provideProductDetailsComponent } from '../layouts';
import { CommonProductDetailLayoutComponentsProviderComponent } from '../types/common/component-provider';
import { WireCutProductDetailLayoutComponentsProviderComponent } from '../types/wire-cut/component-provider/wire-cut-product-detail-layout-components-provider';
import { WireCutProductResultLayoutComponentsProviderComponent } from '../types/wire-cut/component-provider/wire-cut-product-result-layout-components-provider';
import { provideProductType } from './provideProductType';

export function provideWireProductType(): Provider[] {
  return [
    provideProductDetailsComponent({
      type: ProductTypes.Wire,
      component: CommonProductDetailLayoutComponentsProviderComponent,
    }),
    provideItemResultComponent({
      type: ProductTypes.Wire,
      component: CommonItemResultLayoutComponentsProviderComponent,
    }),
    ...provideProductType(ProductTypes.Wire, {
      productResultComponent: WireCutProductResultLayoutComponentsProviderComponent,
      productDetailComponent: WireCutProductDetailLayoutComponentsProviderComponent,
      itemResultComponent: WireCutItemResultLayoutComponentsProviderComponent,
      productDetailsConverter: wireProductDetailsConverter,
      itemConverter: wireItemConverter,
      pricingConverter: wireItemPricingConverter,
    }),
  ];
}
